export default "__VITE_ASSET__BgbGXg$k__"